import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { getSelfServeIntl } from 'client/self_serve/shared/self_serve.intl';
import messages from './messages';

const selfServeIntl = getSelfServeIntl();

const FilterChip = ({
  isActive,
  isOpen,
  clearFilter,
  applyFilter,
  openFilter,
  openFilterWithSpacebar,
  overlayTitle,
  buttonTitle,
  showClearApplyButtons,
  children,
  className,
  ariaLabel,
  id
}) => {
  const buttonClasses = cn('ray-button ray-button--compact filter-chip', {
    'ray-button--primary active': isActive,
    'ray-button--secondary': !isActive,
    open: isOpen
  });

  return (
    <div className={cn('filter-chip-wrapper', className)} id={`${id}-chip-wrapper`}>
      <button
        onMouseDown={openFilter}
        aria-label={ariaLabel}
        onKeyDown={openFilterWithSpacebar}
        className={buttonClasses}
        id={`${id}-chip`}
      >
        {buttonTitle}
      </button>
      <div className={cn('filter-overlay', { animate: isOpen })}>
        <div className="filter-overlay-title">{overlayTitle}</div>
        <div className="filter-overlay-content">
          <div className="filter-form">
            {children}
            {showClearApplyButtons && (
              <button onClick={applyFilter} className="filter-overlay-apply ray-button ray-button--tertiary">
                {selfServeIntl.formatMessage(messages.capacityFilterOverlayApply)}
              </button>
            )}
          </div>
          {showClearApplyButtons && (
            <button onClick={clearFilter} className="filter-overlay-clear ray-button ray-button--tertiary">
              {selfServeIntl.formatMessage(messages.capacityFilterOverlayClear)}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

FilterChip.propTypes = {
  openFilter: PropTypes.func.isRequired,
  openFilterWithSpacebar: PropTypes.func,
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  ariaLabel: PropTypes.string,
  clearFilter: PropTypes.func,
  applyFilter: PropTypes.func,
  buttonTitle: PropTypes.string,
  overlayTitle: PropTypes.string,
  showClearApplyButtons: PropTypes.bool,
  isActive: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string
};

export default FilterChip;
